import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=4ca9daee&"
import script from "./Tables.vue?vue&type=script&lang=jsx&"
export * from "./Tables.vue?vue&type=script&lang=jsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports